import { useTranslation } from 'react-i18next'

import { InputWithLabel, ScrollableTabs } from '@reveni-io/reveni-ui'

import { getLanguageLabels } from '@/configuration/helpers/helpers'

import useLanguageTextInput from './hooks/useLanguageTextInput/useLanguageTextInput'
import * as Styles from './styles'

const LanguageTextInput = ({
  languages,
  value,
  onChange,
  validateEmptyOnBlur = true,
  externalErrorLanguages = [],
  inputLabel,
  helperText,
  showInputError = false,
  maxLength,
  backgroundColor,
  disabled,
}) => {
  const { t } = useTranslation()
  const { orderedLanguages, textLanguage, setTextLanguage, hasError, handleChange, handleBlur } = useLanguageTextInput({
    languages,
    value,
    onChange,
    validateEmptyOnBlur,
    externalErrorLanguages,
  })

  const languageLabels = getLanguageLabels(t)
  const showCurrentError = showInputError && hasError(textLanguage)

  return (
    <Styles.Container>
      <ScrollableTabs
        tabs={orderedLanguages.map(language => ({
          label: languageLabels[language],
          value: language,
          error: hasError(language),
        }))}
        value={textLanguage}
        onChange={setTextLanguage}
      />
      <InputWithLabel
        label={inputLabel}
        onChange={handleChange}
        value={value?.[textLanguage] || ''}
        onBlur={handleBlur}
        fullWidth
        maxLength={maxLength}
        backgroundColor={backgroundColor}
        disabled={disabled}
        error={showCurrentError}
        helperText={showCurrentError && helperText ? helperText : undefined}
      />
    </Styles.Container>
  )
}

export default LanguageTextInput
